import React, { createContext, useContext } from 'react'
import { mergeClasses } from "@/helpers/styling"

export const ItemList = React.forwardRef<
  HTMLUListElement,
  React.HTMLAttributes<HTMLUListElement>
>(function ItemList(props, ref) {
  return (
    <ul ref={ref}
        {...props}
        className={mergeClasses("flex flex-col max-w-full", props.className)}>
      {props.children}
    </ul>
  )
})

const IsSelectedContext = createContext(false)

export function Item(props: React.HTMLAttributes<HTMLLIElement> & {
  selected?: boolean
}) {
  return (
    <li {...props} className={mergeClasses(`
      group max-w-full flex gap-2 items-center
      xxgrid xxxgrid-cols-[minmax(0,1fr)_auto]
      list-none
      border-b border-gray-200
      hover:bg-gray-100 cursor-pointer
    `, {
      "bg-indigo-100 hover:bg-indigo-200": props.selected
    }, props.className)}>
      <IsSelectedContext.Provider value={Boolean(props.selected)}>
        {props.children}
      </IsSelectedContext.Provider>
    </li>
  )
}

export function ItemLabel(props: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={mergeClasses(`
      flex flex-grow gap-2 items-center
      select-none truncate
      px-2 py-[2px]
    `, props.className)}>
      {props.children}
    </div>
  )
}

export function ItemActions(props: React.HTMLAttributes<HTMLDivElement>) {
  const isSelected = useContext(IsSelectedContext)
  return (
    <div {...props} className={mergeClasses(`
      flex gap-1 items-center
      px-1 py-[2px] overflow-hidden
      transition-all duration-300 ease-in-out
      opacity-0 group-hover:opacity-100
      max-w-0 group-hover:max-w-min
    `, {
      "max-w-min opacity-100": isSelected
    }, props.className)}>
      {props.children}
    </div>
  )
}
